import { apiClient } from "@/api";
import { useQuery } from "@tanstack/react-query";

export interface IProjectTeamMember {
  Email: string;
  Project: string;
  Role: string;
  RoleDisplayName: string;
  FullName: string;
  IsActive: boolean;
  Region: string;
}

export const QUERY_KEYS = {
  allTeamMembersList: "PROJECT_TEAM_ALL_TEAM_MEMBERS_LIST",
};

export const useGetProjectTeamMembers = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.allTeamMembersList],
    queryFn: async (): Promise<IProjectTeamMember[]> => {
      const { data } = await apiClient.get("/v3/project-team/all");
      return data;
    },
  });
};
